import { type FC } from "react";
import { PopupModal, useCalendlyEventListener } from "react-calendly";

interface CalendlyModalProps {
  isOpen: boolean;
  onClose: () => void;
  url: string;
  prefill?: { name?: string; email?: string };
  onEventScheduled?: (eventUri: string, inviteeUri: string) => void;
  onDateAndTimeSelected?: () => void;
}

export const CalendlyModal: FC<CalendlyModalProps> = ({
  isOpen,
  onClose,
  url,
  prefill,
  onEventScheduled,
  onDateAndTimeSelected,
}) => {
  useCalendlyEventListener({
    onDateAndTimeSelected: () => {
      if (isOpen) onDateAndTimeSelected?.();
    },
    onEventScheduled: (e) => {
      if (isOpen) {
        onEventScheduled?.(e.data.payload.event.uri, e.data.payload.invitee.uri);
      }
    },
  });

  return (
    <PopupModal
      url={url}
      prefill={prefill}
      open={isOpen}
      onModalClose={onClose}
      rootElement={document.getElementById("root")!}
      pageSettings={{ hideLandingPageDetails: true }}
    />
  );
};
